import { defineMessages } from 'react-intl';

export default defineMessages({
  modalTitle: {
    description: 'Import Results Title',
    defaultMessage: 'Customer Import Results',
    id: 'uYR6/8',
  },
  closeButton: {
    description: 'Modal Close Button',
    defaultMessage: 'Close',
    id: '4mH6gE',
  },
  usernameRequired: {
    description: 'csv import username required error message',
    defaultMessage: 'Error - Row {rowNumber}: Username is a required field.',
    id: 'c/c61J',
  },
  addressLine1Required: {
    description: 'csv import address line 1 required error message',
    defaultMessage: 'Error - Row {rowNumber}: Address Line 1 is a required field.',
    id: 'oD1TMR',
  },
  cityRequired: {
    description: 'csv import city required error message',
    defaultMessage: 'Error - Row {rowNumber}: City is a required field.',
    id: 'lWfJ1q',
  },
  stateRequired: {
    description: 'csv import state required error message',
    defaultMessage: 'Error - Row {rowNumber}: State is a required field.',
    id: 'CxfEl7',
  },
  countryCodeRequired: {
    description: 'csv import country code required error message',
    defaultMessage: 'Error - Row {rowNumber}: Country Code is a required field.',
    id: 'ZPvAxV',
  },
  needsOneOfError: {
    description: 'csv import error message',
    defaultMessage: 'Error - Row {rowNumber}: Records must have at least one of: Company Name, First Name, Last Name, Full Name.',
    id: 'oSvELM',
  },
  skippedWarning: {
    description: 'csv import warning message',
    defaultMessage: 'Warning - Row {rowNumber}: Username {userName} already exists, skipping record.',
    id: 'eWti0W',
  },
});
